<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="analyze-alerts">
    <!-- <pre>{{randomizeArray}}</pre> -->
    <vs-prompt title="Export To Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel" accept-text="Export" @close="clearFields" :active.sync="activePrompt">
        <vs-input v-model="fileName" placeholder="Enter File Name.." class="w-full" />
        <v-select v-model="selectedFormat" :options="formats" class="my-4" />
        <div class="flex">
          <span class="mr-4">Cell Auto Width:</span>
          <vs-switch v-model="cellAutoWidth">Cell Auto Width</vs-switch>
        </div>
    </vs-prompt>
    <!-- <vs-alert active="true" :color="colors.warning" class="mb-3" icon-pack="feather" icon="icon-alert-triangle">
      Alerts needs minimum <strong>last 120 days</strong> of business data for better insight
    </vs-alert> -->
    <div class="vx-row">
      <!-- ACTIVITY TIMELINE -->
      <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <vx-card title="Activity Timeline">
          <template slot="actions">
            <div class="btn-group">
              <vs-button size="small" @click="activity1()" :color="selectedActivity1">Active</vs-button>
              <vs-button size="small" @click="activity2()" :color="selectedActivity2">Archived</vs-button>
            </div>
          </template>
          <ul class="activity-timeline">
            <li>
              <div class="timeline-icon bg-warning">
                <feather-icon icon="PlusIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
              </div>
              <div class="timeline-info">
                <p class="font-semibold">Alert feed published for week 32</p>
                <span class="activity-desc">Check for Sales plunge and Sale build up alerts</span>
              </div>
              <small class="text-grey activity-e-time">03 Aug 2019</small>
            </li>
            <li>
              <div class="timeline-icon bg-warning">
                <feather-icon icon="AlertCircleIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
              </div>
              <div class="timeline-info">
                <p class="font-semibold">Demand Forecast published for week 32</p>
                <span class="activity-desc">Check the forecast under DemFor</span>
              </div>
              <small class="text-grey activity-e-time">03 Aug 2019</small>
            </li>
            <li>
              <div class="timeline-icon bg-primary">
                <feather-icon icon="PlusIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
              </div>
              <div class="timeline-info">
                <p class="font-semibold">Alert feed published for week 31</p>
                <span class="activity-desc">Check for Sales plunge and Sale build up alerts</span>
              </div>
              <small class="text-grey activity-e-time">27 Jul 2019</small>
            </li>
            <li>
              <div class="timeline-icon bg-primary">
                <feather-icon icon="AlertCircleIcon" svgClasses="text-white stroke-current w-5 h-5"></feather-icon>
              </div>
              <div class="timeline-info">
                <p class="font-semibold">Demand Forecast published for week 31</p>
                <span class="activity-desc">Check the forecast under DemFor</span>
              </div>
              <small class="text-grey activity-e-time">27 Jul 2019</small>
            </li>
          </ul>
        </vx-card>
      </div> -->

      <!-- ALERTS -->
      <!-- <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base"> -->
      <div class="vx-col w-full mb-base">
        <vx-card :title="'Alerts Using last '+ activeTimeline.desc +' data'" class="overflow-hidden" v-show="!showAlertContainer">
          <template slot="actions">
            <div class="btn-group">
              <vs-button
                radius
                type="line"
                v-for="tl in timeline"
                :key="tl.days"
                v-bind="{disabled : tl.block}"
                @click="timelineLookup(tl)"
                size="small" :color="tl.selected ? colors.primary : '#aaa'"
                >
                {{tl.label}}
              </vs-button>
            </div>
          </template>
          <template slot="no-body">
            <div
              class="flex justify-between items-center p-6 border border-solid border-grey-light border-r-0 border-l-0 border-t-0"
            >
              <div>
                <p>
                  You have got alerts in <span class="font-semibold">{{containerStat.dataAvailableFor}} queue(s)</span> out of {{containerStat.status.length-3}} queues.
                </p>
                <vs-progress :percent="containerStat.progress" color="primary"></vs-progress>
              </div>

              <!-- <span>{{payload.dateRange.startDate | date(true)}} ~ {{payload.dateRange.endDate | date(true)}}</span> -->
            </div>
            <ul class="tasks-today-container">
              <li class="px-6 py-4 tasks-today__task">
                <div class="vx-row">
                  <div class="vx-col w-full sm:w-auto">
                    <!-- <p
                      class="font-semibold text-lg"
                    >{{alertType('SLOW', true).length}} units have plunge in sale</p> -->
                    <p
                      class="font-semibold text-lg"
                    >{{alertType('BOTTOM').length}} Slow selling SKUs</p>
                    <small>{{payload.dateRange.endDate | date('Y, ( [Wk #]Wo )')}}</small>
                  </div>
                  <div class="tasks-today__actions vx-col w-full sm:w-auto ml-auto mt-2 sm:mt-0">
                    <vs-button
                      color="primary"
                      type="filled"
                      size="small"
                      @click="handleAlertContainer('BOTTOM')"
                    >Check</vs-button>
                    <!-- <vs-button
                      radius
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-check"
                      size="small"
                    ></vs-button>
                    <vs-button
                      radius
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-list"
                      size="small"
                      class="ml-3"
                    ></vs-button>
                    <vs-button
                      radius
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-bookmark"
                      size="small"
                      class="ml-3"
                    ></vs-button> -->
                  </div>
                </div>
              </li>
              <li class="px-6 py-4 tasks-today__task">
                <div class="vx-row">
                  <div class="vx-col w-full sm:w-auto">
                    <!-- <p
                      class="font-semibold text-lg"
                    >{{alertType('FAST').length}} units are picking up in sale</p> -->
                    <p
                      class="font-semibold text-lg"
                    >{{alertType('TOP', true).length}} Top selling SKUs</p>
                    <small>{{payload.dateRange.endDate | date('Y, ( [Wk #]Wo )')}}</small>
                  </div>
                  <div class="tasks-today__actions vx-col w-full sm:w-auto ml-auto mt-2 sm:mt-0">
                    <vs-button
                      color="primary"
                      type="filled"
                      size="small"
                      @click="handleAlertContainer('TOP', true)"
                    >Check</vs-button>
                  </div>
                </div>
              </li>
              <!-- <li class="px-6 py-4 tasks-today__task">
                <div class="vx-row">
                  <div class="vx-col w-full sm:w-auto">
                    <p
                      class="font-semibold text-lg"
                    >{{alertType('OOS').length}} Likely to be OOS SKUs</p>
                    <small>{{payload.dateRange.endDate | date('Y, Wo [Wk]')}}</small>
                  </div>
                  <div class="tasks-today__actions vx-col w-full sm:w-auto ml-auto mt-2 sm:mt-0">
                    <vs-button
                      color="primary"
                      type="filled"
                      size="small"
                      v-if="false"
                      @click="handleAlertContainer('OOS')"
                    >Check</vs-button>
                  </div>
                </div>
              </li> -->
            </ul>
          </template>
        </vx-card>
        <vx-card :title="alertContainerTitle" subtitle="Note: Action priority:  1 higher than 2, 2 higher than 3, .. " v-show="showAlertContainer">
          <template slot="actions">
            <!-- <feather-icon
              icon="XCircleIcon"
              svgClasses="w-6 h-6 text-grey"
              @click="hideAlertContainer"
            ></feather-icon> -->

            <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
              <!-- <feather-icon
                icon="XCircleIcon"
                class="cursor-pointer"
                :svgClasses="['w-5', 'h-5 mr-4']"
                @click.stop="hideAlertContainer" /> -->

              <feather-icon
                icon="DownloadIcon"
                class="cursor-pointer"
                v-if="alertContainer.length > 0"
                :svgClasses="[{'text-success stroke-current': alertContainer.length > 0}, 'w-5', 'h-5 mr-4']"
                @click.stop="activePrompt=true" />

              <feather-icon
                icon="XCircleIcon"
                class="cursor-pointer"
                :svgClasses="['w-5', 'h-5 mr-4']"
                @click.stop="hideAlertContainer" />

            </div>

            <!-- <vs-button @click="activePrompt=true">Export</vs-button> -->
          </template>
          <template>
            <vs-table ref="table" :data="alertContainer" pagination :max-items="itemsPerPage" search stripe>
              <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <!-- <pre>{{currentPage}}, {{itemsPerPage}}, {{alertContainer.length}}, {{queriedItems}}</pre> -->
                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <!-- <span class="mr-2">{{ (currentPage * itemsPerPage) - (itemsPerPage - 1) }} - {{ (alertContainer.length - (currentPage * itemsPerPage)) > 0 ? (currentPage * itemsPerPage) : alertContainer.length }} of {{ queriedItems }}</span> -->
                    <span class="mr-2">Line items per page:  {{ itemsPerPage }}</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=4">
                      <span>4</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=10">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                      <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=20">
                      <span>20</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>


              <template slot="thead">
                <vs-th></vs-th>
                <vs-th sort-key="desc">SKU</vs-th>
                <vs-th sort-key="cat_lookup">Category / Sub Category</vs-th>
                <vs-th sort-key="brand">Brand</vs-th>
                <vs-th sort-key="stock_qty">Inventory</vs-th>
                <!-- <vs-th sort-key="c2c">Cost to Company</vs-th> -->
                <vs-th sort-key="quantity">Units/Day</vs-th>
                <vs-th>Weekly Trend ( Units )</vs-th>
                <!-- <vs-th>Sales Trend ( {{ '' | currencySymbol }} )</vs-th> -->
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td>{{ data[indextr].row ? data[indextr].row : (indextr+1) }}</vs-td>
                  <vs-td :data="data[indextr].desc">{{ data[indextr].desc }}<br><small class="text-grey">{{ data[indextr].sku_id }}</small></vs-td>
                  <vs-td :data="data[indextr].cat_lookup">{{ data[indextr].cat_lookup }}</vs-td>
                  <vs-td :data="data[indextr].brand">{{ data[indextr].brand }}</vs-td>
                  <vs-td :data="data[indextr].stock_qty">{{ data[indextr].stock_qty | numFormat }}</vs-td>
                  <!-- <vs-td :data="data[indextr].c2c"> - </vs-td> -->
                  <vs-td align="right" :data="data[indextr].quantity">{{ data[indextr].quantity}}</vs-td>
                  <vs-td>
                    <vue-apex-charts
                      :name="'trend-'+indextr"
                      type="area"
                      height="35"
                      width="150"
                      :options="sparkLine"
                      :series="seriesSpark(data[indextr])"
                    />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import vSelect from 'vue-select';

import { appCommons } from '@/app/shared/services';
import appConfig from "@/../appConfig.js";

import { actionsTypes } from "../shared/state";

const themeColors = appConfig.chart.colors;

export default {
  components: {
    VueApexCharts,
    VuePerfectScrollbar,
    vSelect
  },
  data() {
    return {
      isNavOpen: false,
      type: "all",
      activeSearch: null,
      filterReset: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.7
      },
      wasSidebarOpen: null,
      colors: appConfig.colors,
      isLoading: false,
      timeline: [{
        label: "1 w",
        desc: "1 week",
        days: 7,
        selected: false
      }, {
        label: "2 w",
        desc: "2 weeks",
        days: 14,
        selected: false
      }, {
        label: "4 w",
        desc: "4 weeks",
        days: 28,
        selected: false
      }, {
        label: "5 w",
        desc: "5 weeks",
        days: 35,
        selected: false
      }, {
        label: "13 w",
        desc: "13 weeks",
        days: 91,
        selected: true
      }, {
        label: "26 w",
        desc: "26 weeks",
        days: 182,
        selected: false
      }, {
        label: "52 w",
        desc: "52 weeks",
        days: 364,
        selected: false
      }],
      activeTimeline: {
        label: "13 w",
        desc: "13 weeks",
        days: 91,
        selected: true
      },
      payload: {
        tags: [],
        dateRange: appCommons.allowedDateScope('', 91, '', ''),
        query: "",
        mode: "quantity",
        type: "ALERTS",
        res: {}
      },
      selectedActivity: "Active",
      selectedActivity1: "success",
      selectedActivity2: "primary",

      showAlertContainer: false,
      alertContainerTitle: "",
      alertContainer: [],
      // containerStat: {},
      containerStat: {
        status: [{
          type: 'TOP',
          len: 0
        }, {
          type: 'BOTTOM',
          len: 0
        }, {
          type: 'SLOW',
          len: 0
        }, {
          type: 'FAST',
          len: 0
        }, {
          type: 'OOS',
          len: 0
        }],
        dataAvailableFor: 0,
        progress: 0
      },
      sparkLine: {
        chart: {
          height: 35,
          sparkline: {
            enabled: true
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '80%'
          }
        },
        colors: themeColors,
        stroke: {
          curve: "smooth",
          dashArray: [0, 8],
          width: [2, 2]
        },
        fill: {
          opacity: 0.3
        },
        xaxis: {
          crosshairs: {
            width: 1
          },
        },
        tooltip: {
          custom: function({ series, seriesIndex, dataPointIndex, w }) {

              return (
                '<div class="custom-tooltip">' +
                '<div class="group1">' +
                "<div><span>" +
                 'wk #'+ (dataPointIndex + 1) +' - '+ series[seriesIndex][dataPointIndex] +
                "</span> <br />" +
                "</div>" +
                "</div>" +
                "</div>"
              );

              // return w.config.series[0].categories[dataPointIndex];
            },
          fixed: {
            enabled: false
          },
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function (seriesName) {
                return ''
              }
            }
          },
          marker: {
            show: false
          }
        }
      },

      fileName: "",
      formats:["xlsx", "csv", "txt"] ,
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["Row", "SKU Id", "Desc", "Category", "Brand", "Cost to Company","Inventory", "Units / Day"],
      headerVal: ["row", "sku_id", "desc", "cat_lookup", "brand","c2c", "inventory", "quantity"],
      activePrompt: false,

      itemsPerPage: 4,
      isMounted: false,

    };
  },
  methods: {
    init() {
      this.$vs.loading({
        // background: this.backgroundLoading,
        // color: this.colorLoading,
        // container: "#analyze-app",
        // scale: 0.45,
        type: "radius"
      });

      this.payload.dateRange = appCommons.allowedDateScope('', this.activeTimeline.days, 'minus');

      this.$store.dispatch('analyze/'+ actionsTypes.FETCH_ANALYZE_ARTEFACT, this.payload);
      this.showAlertContainer = false;
    },
    timelineLookup(tl) {
      for(var t of this.timeline) {
        if(t.days === tl.days) {
          t.selected = true;
          this.activeTimeline = t;
        } else {
          t.selected = false;
        }
      }
      this.init();
    },
    activity1() {
      this.selectedActivity = "Active";

      this.selectedActivity1 = "success";
      this.selectedActivity2 = "primary";
    },
    activity2() {
      this.selectedActivity = "Archived";

      this.selectedActivity1 = "primary";
      this.selectedActivity2 = "success";
    },
    alertType(type, reverse) {
      this.checkContainerStatus();
      let alerts = this.filterAndSortData(type, this.alerts);

      if(!reverse) {
        alerts = alerts.reverse();
      }

      // if(type === 'TOP') {
        alerts = alerts.slice(0, 100);
      // }

      return alerts;
    },
    filterAndSortData(rtype, data) {

      let filteredData = data.filter(
        t => ( 
          (rtype === 'TOP' ? true: false) || 
          (rtype === 'BOTTOM' ? t.quantity < 1 : false) || 
          (rtype !== 'TOP' && rtype !== 'BOTTOM'? t.alert === rtype : false)
        )
      )
      return filteredData;
      // return filteredData.sort(function(t1, t2) {
      //   var upd1 = t1.quantity ? t1.quantity : t1.retail_price;
      //   var upd2 = t2.quantity ? t2.quantity : t2.retail_price;

      //   var cat1 = t1.product_category;
      //   var cat2 = t2.product_category;

      //   if (upd1 < upd2) {
      //     return -1;
      //   } else if (upd1 > upd2) {
      //     return 1;
      //   } else if (cat1 < cat2) {
      //     return 1;
      //   } else if (cat1 > cat2) {
      //     return -1;
      //   }

      //   // tags must be equal
      //   return 0;
      // });

    },
    handleAlertContainer(type, reverse) {
      this.alertContainer = this.alertType(type, reverse);

      if(this.alertContainer.length > 0) {
        for(var i = 0; i < this.alertContainer.length; i++) {
          this.alertContainer[i].row = i+1;
          this.alertContainer[i].Alert_Rank = Number(this.alertContainer[i].Alert_Rank)+1;
        }
      }

      this.alertContainerTitle = this.alertContainer.length + " units show " + ((type === "BOTTOM") ? "Slow Sale" : ((type === "OOS") ? "Out of Stock" : "Fast Sale"));
      this.fileName = (type === "BOTTOM") ? "SlowSale_Alerts_Using_"+this.activeTimeline.days+"days_Data": ((type === "OOS") ? "OOS_Alerts_For_"+this.activeTimeline.days+"days": "FastSale_Alerts_Using_"+this.activeTimeline.days+"days_Data");
      this.showAlertContainer = true;
    },
    hideAlertContainer() {
      this.alertContainerTitle = "";
      this.fileName = "";
      this.showAlertContainer = false;
    },
    randomizeArray() {
      let sparklineData = [47, 45, 54, 38, 56, 24, 65, 31, 37, 39, 62, 51, 35, 41, 35, 27, 93, 53, 61, 27, 54, 43, 19, 46];

      let array = sparklineData.slice();
      let currentIndex = array.length,
        temporaryValue, randomIndex;

      while (0 !== currentIndex) {

        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array.slice(0, 5);
    },
    seriesSpark(data) {
      let series = [{
        data: []
      }];
      // console.log('data', data);
      for(let i=0; i < 25; i++) {
        if(isNaN(data[i])) break;
        series[0].data.push(isNaN(data[i]) ? 0 : data[i]);
      }

      // if(series[0].data.length < 1) {
      //   series[0].data = this.randomizeArray();
      // }
      return series;
    },
    checkContainerStatus() {
      let dataAvailableFor = 0;
      for(var a of this.containerStat.status) {
        let typeData = this.alerts.filter(f => f.alert === a.type);
        if(typeData.length > 0) {
          a.len = typeData.length;
          dataAvailableFor++;
        }
      }
      this.containerStat.dataAvailableFor = dataAvailableFor;
      this.containerStat.progress = this.progressPerc();
    },
    progressPerc() {
      return (this.containerStat.dataAvailableFor/(this.containerStat.status.length-3))*100;
    },

    exportToExcel() {
      import('@/app/shared/vendor/Export2Excel').then(excel => {
        const list = this.alertContainer
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    clearFields() {
      this.filename = "",
      this.cellAutoWidth = true,
      this.selectedFormat = "xlsx"
    }
  },
  computed: {
    alerts() {
      return this.artefact && this.artefact.res ? this.artefact.res : [];
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table ? this.$refs.table.currentx : 1
      }
      return 1
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.alerts.length
    },

    ...mapGetters({artefact: "analyze/artefact"})
  },
  mounted() {
    this.wasSidebarOpen = this.$store.state.reduceButton;
    this.$store.commit("TOGGLE_REDUCE_BUTTON", true);
    this.init();
    this.filterReset = true;
    this.isMounted = true;

    this.$store.watch(
      (state, getters) => getters["analyze/isLoading"],
      (newValue, oldValue) => {
        this.isLoading = newValue;
        if (this.isLoading) {
          this.$vs.loading({
            // background: this.backgroundLoading,
            // color: this.colorLoading,
            // container: "#analyze-alerts",
            // scale: 0.45,
            type: "radius"
          });
        }

        if (!this.isLoading) {
          this.$vs.loading.close();
          // this.$vs.loading.close("#analyze-alerts > .con-vs-loading");
        }
      }
    );
  },
  beforeDestroy() {
    if (!this.wasSidebarOpen) this.$store.commit("TOGGLE_REDUCE_BUTTON", false);
  },
  watch: {
    "$store.state.AppScopeTrack"(val) {
      this.init();
    },
  },

};
</script>

<style lang="scss">
#analyze-alerts {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .tasks-today-container {
    .tasks-today__task {
      transition: background 0.15s ease-out;
      .tasks-today__actions {
        display: none;
      }

      &:hover {
        background: #f8f9ff;
        .tasks-today__actions {
          display: flex;
        }
      }
    }
  }

  .custom-tooltip {
    padding:5px;
    background: #fff;
  }
}
</style>
